import { Draft } from 'immer'
import { BlockConnectorCandidatesResponse } from '../types'
import { findConnectionCandidate, generateCandidateId } from '../utils'

type CreateViewForBlockConnectorCandidateParams = {
  parentBlockId: string
  supportiveViewId: string
  supportiveCategoryId: string
}

export function createViewForBlockConnectorCandidate({
  parentBlockId,
  supportiveViewId,
  supportiveCategoryId,
}: CreateViewForBlockConnectorCandidateParams) {
  return (draft: Draft<BlockConnectorCandidatesResponse>) => {
    const candidate = findConnectionCandidate(
      draft.data,
      generateCandidateId(parentBlockId, null, null)
    )
    if (!candidate) return draft

    candidate.supportive_view_id = supportiveViewId
    candidate.supportive_category_id = supportiveCategoryId
    return draft
  }
}
